import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Typography,
  Box,
  PaginationItem,
  Menu,
  MenuItem,
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import styled from "@emotion/styled";
import AssignmentIcon from "@mui/icons-material/Assignment";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import NoDataFound from "../../Components/Masters/NoDataFound";
import { getMonthName } from "../../utils/getMonthName";
import PaginationBox from "../Masters/Pagination";
import { truncateNumber } from "../../utils/common";
import { formatDate, formatDateMonth } from "../../utils/formatDate";

const ViewTable = ({
  title,
  headers,
  data,
  onSort,
  sortConfig,
  page,
  count,
  onPageChange,
  onView,
  onEdit,
  onDelete,
  editIcon,
  totalPages,
  tableContainerRef,
  isShortContent,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleMenuOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
    "&.Mui-selected": {
      backgroundColor: "green",
      color: "#fff",
      fontWeight: "bold",
    },
    "&:hover": {
      backgroundColor: "#ededed",
    },
  }));

  const handlePageChange = (event, newPage) => {
    onPageChange(newPage);
  };

  const getMonth = (dateStr) => {
    const date = new Date(dateStr);

    return date.toLocaleString("default", { month: "short", year: "numeric" });
  };

  return (
    <>
      <TableContainer
        component={Paper}
        ref={tableContainerRef}
        sx={{
          width: "100%",
          borderRadius: "8px",
          marginBottom: "1.5rem",
          borderBottom: "1px solid #ddd",
          borderTop: "1px solid #ddd",
        }}
      >
        <Box sx={{ padding: "1rem 0.5rem" }}>
          <Box
            sx={{
              fontWeight: "bold",
              fontSize: "20px",
              textAlign: "left",
            }}
          >
            {title ? title : "Table"}
          </Box>
        </Box>
        <Table sx={{ tableLayout: "fixed" }}>
          <TableHead sx={{ backgroundColor: "#fff" }}>
            <TableRow sx={{ width: "100%" }}>
              {headers.map((header) => (
                <TableCell
                  key={header.key}
                  sx={{
                    borderRight: "1px solid #ddd",
                    borderTop: "1px solid #ddd",
                    padding: "10px",
                    width: header.width,
                    // overflow: "hidden",
                    // textOverflow: "ellipsis",
                    // whiteSpace: "nowrap",
                  }}
                >
                  <Box display="flex" alignItems="center">
                    <Typography
                      sx={{
                        fontWeight: "600",
                        flexGrow: 1,
                        fontSize: "16px",
                        // overflow: "hidden",
                        // textOverflow: "ellipsis",
                        // whiteSpace: "nowrap",
                      }}
                    >
                      {header.label}
                    </Typography>
                    {header.sortable && (
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                      >
                        <IconButton
                          size="small"
                          onClick={() => onSort(header.key, "asc")}
                        >
                          <ExpandLess
                            sx={{
                              fontSize: "20px",
                              margin: "-10px",
                              fontWeight: "700",
                              color:
                                sortConfig.key === header.key &&
                                sortConfig.direction === "asc"
                                  ? "blue"
                                  : "black",
                            }}
                          />
                        </IconButton>
                        <IconButton
                          size="small"
                          onClick={() => onSort(header.key, "desc")}
                        >
                          <ExpandMore
                            sx={{
                              fontSize: "20px",
                              fontWeight: "700",
                              margin: "-10px",
                              color:
                                sortConfig.key === header.key &&
                                sortConfig.direction === "desc"
                                  ? "blue"
                                  : "black",
                            }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  </Box>
                </TableCell>
              ))}
              <TableCell
                key={"actions"}
                sx={{
                  borderTop: "1px solid #ddd",
                  padding: "10px 16px",
                  fontSize: "16px",
                  fontWeight: "600",
                  width: "10%",
                  textAlign: "center",
                }}
              >
                Action
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {data?.length === 0 ? (
              <TableRow sx={{ width: "100%" }}>
                <TableCell
                  colSpan={headers.length + 1}
                  sx={{ textAlign: "center", padding: "20px" }}
                >
                  <NoDataFound />
                </TableCell>
                {/* <NoDataFound /> */}
              </TableRow>
            ) : (
              data?.map((row) => (
                <TableRow key={row.id} size="small">
                  {headers.map((header) => (
                    <TableCell
                      key={header?.key}
                      size="small"
                      sx={{
                        borderRight: "1px solid #ddd",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        padding: "8px 12px",

                        fontSize: "14px",
                        lineHeight: "1",
                        width: header.width,
                        textAlign:
                          header.key === "createdAt" ? "center" : "left",
                      }}
                    >
                      {/* <Tooltip title={row[header.key] || "N/A"} placement="top"> */}
                      <Typography
                        sx={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          fontSize: "14px",
                        }}
                      >
                        {header.key === "createdAt" ||
                        header.key === "dateOfTravel" ||
                        header.key === "date" ||
                        header.key === "dateOfSale"
                          ? formatDateMonth(row[header.key])
                          : header.key === "monthYear" ||
                            header.key === "consumptionPeriod"
                          ? `${getMonthName(
                              row?.data
                                ? row?.data?.[header.key]?.month
                                : row?.[header.key]?.month
                            )} ${
                              row?.data
                                ? row?.data?.[header.key]?.year
                                : row?.[header.key]?.year
                            }`
                          : header.key === "month"
                          ? getMonth(row[header.key])
                          : header.key === "unitOfProductSold"
                          ? (() => {
                              const u = row.unitOfProductSold;
                              if (u && typeof u === "object") {
                                const qty =
                                  u.value !== undefined && u.value !== null
                                    ? u.value
                                    : "";
                                const unit = u.unit || "";
                                const combined = `${qty} ${unit}`.trim();
                                return combined || "N/A";
                              }
                              return row.unitOfProductSold || "N/A";
                            })()
                          : header.key === "assetSize"
                          ? (() => {
                              const a = row.assetSize;
                              if (a && typeof a === "object" && a !== null) {
                                // If it's an object, extract the value
                                const val =
                                  a.value !== undefined && a.value !== null
                                    ? a.value
                                    : "";
                                return val || "N/A";
                              }
                              return a || "N/A";
                            })()
                          : header.subKey
                          ? row[header.key]?.[header.subKey] || "N/A"
                          : header.key === "test"
                          ? `${row[header.key]?.value} ${row[header.key]?.unit}`
                          : header.key === "productName"
                          ? row[header.key] || "N/A"
                          : header.field
                          ? `${row[header.key]?.[header.field] || "N/A"}`
                          : header.key === "freightLoad" ||
                            header.key === "distanceCovered"
                          ? `${truncateNumber(row[header.key]?.value)}`
                          : header.key === "quantityOfWasteGenerated" ||
                            header.key === "quantityOfWasteManaged" ||
                            header.key === "quantityProduced"
                          ? truncateNumber(row[header.key]?.value || 0) +
                            " " +
                            row[header.key]?.unit
                          : header.truncate
                          ? truncateNumber(row[header.key])
                          : row[header.key] || "N/A"}
                      </Typography>

                      {/* </Tooltip> */}
                    </TableCell>
                  ))}
                  <TableCell
                    sx={{
                      textAlign: "center",
                      padding: "0px 6px",
                      fontSize: "14px",
                      lineHeight: "1",
                    }}
                  >
                    <IconButton onClick={(event) => handleMenuOpen(event, row)}>
                      <MoreHorizIcon
                        sx={{ fontWeight: "bold", color: "black" }}
                      />
                    </IconButton>
                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={handleMenuClose}
                      PaperProps={{
                        sx: {
                          width: "120px",
                          border: "1px solid #ddd",
                          marginLeft: "-47px",
                          boxShadow: "none",
                        },
                      }}
                    >
                      <MenuItem
                        onClick={() => {
                          handleMenuClose();
                          onView(selectedRow);
                        }}
                        sx={{ fontSize: "14px" }}
                      >
                        <AssignmentIcon
                          sx={{ marginRight: "8px", fontSize: "large" }}
                        />{" "}
                        View Logs
                      </MenuItem>
                      {editIcon !== "disable" && typeof onEdit === "function" ? (
                        <MenuItem
                          onClick={() => {
                            handleMenuClose();
                            onEdit(selectedRow);
                          }}
                          sx={{ fontSize: "14px" }}
                        >
                          <EditIcon
                            sx={{ marginRight: "8px", fontSize: "large" }}
                          />{" "}
                          Edit
                        </MenuItem>
                      ) : null}

                      {editIcon !== "disable" && typeof onDelete === "function" ? (
                        <MenuItem
                          onClick={() => {
                            handleMenuClose();
                            onDelete(selectedRow);
                          }}
                          sx={{ fontSize: "14px" }}
                        >
                          <DeleteIcon
                            sx={{ marginRight: "8px", fontSize: "large" }}
                          />{" "}
                          Delete
                        </MenuItem>
                      ) : (
                        ""
                      )}
                    </Menu>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {totalPages > 1 && (
        <PaginationBox
          {...{
            totalPages,
            page,
            handleChangePage: handlePageChange,
            StyledPaginationItem,
            isShortContent,
          }}
        />
      )}
    </>
  );
};

export default ViewTable;
